import { Box, Button, Grid, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import { useRecoilValue, useRecoilCallback } from "recoil"
import { PlatformPeopleService } from "../../../Component/Api/PlatformPeople/PlatformPeopleService"
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable"
import { MDTypography } from "../../../Component/Common/Components/MDTypography"
import { ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption"
import { PlatformPeople } from "../../../Component/Model/Dto/Platform/PlatformPeople"
import { ExportKeyValue } from "../../../Component/Model/Dto/Upload"
import { EntriesPerPage } from "../../../Component/Model/Table/Table"
import { OrganisationAtom } from "../../../State/Organisation.Atom"
import config from "../../../config"
import { PlatformPeopleTableMapper } from "./PlatformPeopleTableColumns"
import { MDAlert } from "../../../Component/Common/Components/MDAlert"
import { DataImportType } from "../../../Component/Model/Enum/BEE123Enums"
import { IFilter, FilterType } from "../../../Component/Common/Components/DataTable/Filters"
import { UserAtom, userRolesState } from "../../../State/user.Atom"
import { Export } from "../../../Component/Model/Dto/Export"
import { CoreExportService } from "../../../Component/Api/Export/CoreExportService"
import { ConfirmationDialog } from "../../../Component/Common/Components/ConfirmationDialog"
import { MDProgress } from "../../../Component/Common/Components/MDProgress"
import { PlatformImportModal } from "./Import/PlatformImportModal"
import { MerSETASDEService } from "../../../Component/Api/merSETA/External/MerSETASDEService"
import { MerSetaSDESearchRequest as MersetaSDESearchRequest } from "../../../Component/Model/Dto/WSP/MerSETASDE"
import { MersetaLAISearchRequest } from "../../../Component/Model/Dto/WSP/MerSETALAI"
import { MerSETALAIService } from "../../../Component/Api/merSETA/LAI/MerSETALAIService"
import { WarningDialogWithTable } from "../../../Component/Common/Components/WarningDialogWithTable"
import { defaultObject } from "../../../Helpers/typescriptHelper"
import { MersetaDelete } from "../../../Component/Model/Dto/WSP/MerSetaDelete"
import { InterventionAtom } from "./Training/Intervention.Atom"
import { MerSETASDIService } from "../../../Component/Api/merSETA/Internal/MerSETASDIService"
import { MerSetaSDITrainerSearchInput, MersetaSdiSearchRequest } from "../../../Component/Model/Dto/WSP/MerSETASDI"
import { PlatformPeopleEditRole, UserAdminRole } from "../../../Component/Common/Constants/UserRoles"
import {useSignalRConnection} from "../../../Hooks/useSignalRConnection";

export const OrganisationPeoplePage = () => {
  const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);
  const history = useHistory();

  const CreatePersonPage = () => {
    history.push(`/organisation/people/person`)
  }

  const [platformPeopleData, setPlatformPeopleData] = useState<PlatformPeople[]>([]);
  const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
  const [filteredItemCount, setFilteredItemCount] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
  const [showWarningDialog, setShowWarningDialog] = useState<boolean>(false);
  const [selectedPersonId, setSelectedPersonId] = useState<string>();
  const [selectedPersonName, setSelectedPersonName] = useState<string>()
  const [filters, setFilters] = useState({ raceId: [], genderId: [] });
  const [searchValue, setSearchValue] = useState<string>("");
  const [progress, setProgress] = useState(0);
  const [fileExporting, setFileExporting] = useState<boolean>(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [tableData, setTableData] = useState<MersetaDelete[]>(defaultObject);
  const [itemCount, setItemCount] = useState<number>(0);
  const user = useRecoilValue(UserAtom);
  const intervention = useRecoilValue(InterventionAtom);
  const [trainingType, setTrainingType] = useState<string | null>(null);
  const [associationType, setAssociationType] = useState<string | null>(null);
  const [showing, setShowing] = useState<number>(0);
  const hub = useSignalRConnection("ImportHub");

  const editRoleAccess = [
    PlatformPeopleEditRole,
    UserAdminRole
  ]

  const userRoles = useRecoilValue(userRolesState);
  const isEditable = userRoles.some(r => editRoleAccess.includes(r));

  const setIntervention = useRecoilCallback(({ set }) => (id: number) => {
    set(InterventionAtom, { id });
  });

  const platformPeopleFilters: Array<IFilter> = [
    {
      label: 'Race:',
      values: [{ key: 'African', val: 1 }, { key: 'Coloured', val: 2 }, { key: 'Indian', val: 3 }, { key: 'White', val: 4 }, { key: 'Non South African', val: 5 }],
      type: FilterType.multiselect, propname: 'raceIds',
    },
    {
      label: 'Gender:',
      values: [{ key: 'Male', val: 1 }, { key: 'Female', val: 2 }],
      type: FilterType.multiselect, propname: 'genderIds'
    },
  ]



  useEffect(() => {
    if (peopleAndTrainingOrganisation.OrganisationId > 0) {
      fetchPeople();
    }
  }, [peopleAndTrainingOrganisation, entriesPerPage, pageNumber, columnSortOptions, filters, searchValue]);


  useEffect(() => {
    (async () => {
      try {
        if(!hub.isConnected)
        {
          await hub.start();
        }

        hub.on(`exportProgress-${user.username}-${DataImportType[DataImportType.PlatformPeople]}`, (data: any) => {
          setFileExporting(true);
        })
        hub.on(`exportProgressUpdate-${user.username}-${DataImportType[DataImportType.PlatformPeople]}`, (data: any) => {
          setProgress(data.progress);
          setFileExporting(true);
        })
        hub.on(`exportProgressFailed-${user.username}-${DataImportType[DataImportType.PlatformPeople]}`, (data: any) => {
          setFileExporting(false);
          toast.error("Export Failed");
        })
        hub.on(`exportProgressCompleted-${user.username}-${DataImportType[DataImportType.PlatformPeople]}`, (data: any) => {
          setFileExporting(false);
          setProgress(0);
          window.open(data.ExportUrl, "_blank");
        })
      } catch (error) {
        console.error("SignalR connection failed:", error);
      }
    })();
  }, []);

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const columnSortingChanged = (sortOption: ColumnSortOption) => {
    setColumnSortOptions(sortOption)
    setPageNumber(1);
  };

  const searchValueChanged = (value: string) => {
    setSearchValue(value);
    setPageNumber(1);
  }

  const filtersChanged = async (filterProps: any) => {
    const raceId = filterProps['raceIds'] || null;
    const genderId = filterProps['genderIds'] || null;
    setFilters({ raceId, genderId });
    setPageNumber(1);
  };

  const handleRouteToAttendeeClick = (trainingType: string, associationType: string, id: number) => {
    setTrainingType(trainingType);
    setAssociationType(associationType)
    setIntervention(id);
  }

  useEffect(() => {
    if (trainingType !== null && associationType !== null) {
      window.open(`${config.reactPublicUrl}/organisation/training/${trainingType}/form/${associationType}s`, '_blank');
    }
  }, [intervention]);

  const showDeleteConfirmation = async (personId: string, fullName: string) => {
    setSelectedPersonId(personId);
    setSelectedPersonName(fullName);
    const organisationId = peopleAndTrainingOrganisation.OrganisationId;
    const externalTrainingSearchRequest: MersetaSDESearchRequest = {
      organisationId: organisationId,
      personId: personId,
      pageNumber: 1,
      pageSize: entriesPerPage.defaultValue!
    }

    const laiTrainingSearchRequest: MersetaLAISearchRequest = {
      organisationId: organisationId,
      personId: personId,
      pageNumber: 1,
      pageSize: entriesPerPage.defaultValue!
    }

    const internalTrainingSearchRequest: MersetaSdiSearchRequest = {
      organisationId: organisationId,
      personId: personId,
      pageNumber: 1,
      pageSize: entriesPerPage.defaultValue!
    }

    const internalTrainersSearch: MerSetaSDITrainerSearchInput = {
      organisationId: organisationId,
      personId: personId,
      pageNumber: 1,
      pageSize: entriesPerPage.defaultValue!
    }

    try {

      const [assignedExternal, assignedLAI, assignedInternal, trainingInternal] = await Promise.all([
        MerSETASDEService.Search(externalTrainingSearchRequest),
        MerSETALAIService.SearchMerSetaLais(laiTrainingSearchRequest),
        MerSETASDIService.SearchMerSetaSDIs(internalTrainingSearchRequest),
        MerSETASDIService.TrainerSearch(internalTrainersSearch)
      ]);

      const resultLength = assignedExternal.data.filteredItemsCount + assignedLAI.data.filteredItemsCount + assignedInternal.data.filteredItemsCount + trainingInternal.data.filteredItemsCount;

      if (resultLength == 0) {
        setShowConfirmationDialog(true);
      } else if (resultLength > 0) {
        setItemCount(resultLength);
        if (resultLength >= 10) {
          setShowing(10)
        }
        else {
          setShowing(resultLength);
        }
        const combinedTrainingData: MersetaDelete[] = [
          ...assignedExternal.data.results.map((externalData) => ({
            setaId: externalData.id,
            courseName: `External: ${externalData.courseName}`,
            startEndDate: externalData.startEndDate,
            association: "Attendee",
            trainingType: "External"
          })),
          ...assignedLAI.data.results.map((laiData) => ({
            setaId: laiData.id,
            courseName: `LAI: ${laiData.courseName}`,
            startEndDate: laiData.startEndDate,
            association: "Attendee",
            trainingType: "LAI"
          })),
          ...assignedInternal.data.results.map((internalData) => ({
            setaId: internalData.id,
            courseName: `Internal: ${internalData.courseName}`,
            startEndDate: internalData.startEndDate,
            association: "Attendee",
            trainingType: "Internal"
          })),
          ...trainingInternal.data.results.map((internalData) => ({
            setaId: internalData.sdiId,
            courseName: `Internal: ${internalData.courseName}`,
            startEndDate: internalData.startEndDate,
            association: "Trainer",
            trainingType: "Internal"
          })),
        ];
        setTableData(combinedTrainingData);

        setShowWarningDialog(true);
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handleCloseWarning = () => {
    setShowWarningDialog(false);
  }

  const handleDelete = async () => {
    try {

      if (selectedPersonId) {
        await PlatformPeopleService.deletePlatformPerson(selectedPersonId);
        toast.success(`Successfully deleted person: ${selectedPersonName}`);
      }

    } catch (error) {
      console.log(error);
    } finally {
      handleCloseConfirmation();
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmationDialog(false);
    fetchPeople();
  }

  const onExportData = async () => {
    setIsLoading(true)
    let params: ExportKeyValue[] = [];

    params.push({ key: "organisationId", value: peopleAndTrainingOrganisation.OrganisationId.toString() });
    params.push({ key: "searchValue", value: searchValue });

    for (const [name, value] of Object.entries(filters)) {
      const tempExportKeyValue = { key: name, value: value?.toString() };
      params.push(tempExportKeyValue);
    }

    const data: Export.DynamicFileExportDto = {
      importType: DataImportType.PlatformPeople,
      parameters: params
    }
    setFileExporting(true);
    try {
      await CoreExportService.FileExportFunction(data);
    } catch (error) {
      console.log(error);
      toast.error("Export Failed");
    } finally {
      params = [];
      setIsLoading(false);
    }
  }

  const fetchPeople = async () => {
    setIsLoading(true);
    try {
      let platformPeopleResult = await PlatformPeopleService.searchPlatformPeople(peopleAndTrainingOrganisation.OrganisationId, columnSortOptions, searchValue, filters.raceId, filters.genderId, pageNumber, entriesPerPage.defaultValue);
      setPlatformPeopleData(platformPeopleResult.data.results);
      setFilteredItemCount(platformPeopleResult.data.filteredItemsCount);
      setTotalItemsCount(platformPeopleResult.data.totalItemsCount);
    } catch (error) {
      console.log(error);
      setTotalItemsCount(1);
    } finally {
      setIsLoading(false);
    }
  }

  const closeImportModal = () => {
    setIsImportModalOpen(false);
    fetchPeople();
  }

  const editPerson = (personId: string) => {
    history.push(`/organisation/people/person/edit/${personId}`)
  }

  const confirmDeleteMessage = `Are you sure you want to delete the person: ${selectedPersonName}`;
  const warningMessage = `Unfortunately, ${selectedPersonName} cannot be deleted because there are associations to the below training interventions. You can only delete this person once all associations have been deleted.`;

  const platformPeopleTableData = PlatformPeopleTableMapper(platformPeopleData, editPerson, showDeleteConfirmation);

  return (
    <>
      <Typography variant="h4" style={{ paddingBottom: "20px" }}>
        People
      </Typography>
      <Typography variant="body2" style={{ paddingBottom: "20px" }}>
        Manage your people for {peopleAndTrainingOrganisation.OrganisationName}.
      </Typography>
      {isEditable &&
        <Button color="primary" variant="contained" onClick={() => { CreatePersonPage() }}>CAPTURE PERSON</Button>
      }
      <DataTable
        table={platformPeopleTableData}
        entriesPerPage={entriesPerPage}
        filters={platformPeopleFilters}
        pageNumber={pageNumber}
        filteredItemsCount={filteredItemCount}
        totalItemsCount={totalItemsCount}
        entriesPerPageChanged={entriesPerPageChanged}
        pageNumberChanged={pageNumberChanged}
        filtersChanged={filtersChanged}
        searchValueChanged={searchValueChanged}
        isLoading={isLoading}
        canSearch={true}
        manualSorting={true}
        columnSortingChanged={columnSortingChanged}
      />

      {isImportModalOpen && <PlatformImportModal open={isImportModalOpen} closeModal={closeImportModal} organisationId={peopleAndTrainingOrganisation.OrganisationId} />}
      {isEditable &&
        <MDAlert color='light' mt={3}>
          {fileExporting ?
            <Grid container justifyContent="center" alignItems="center" direction="column">
              <Typography variant="h6" mb={1}>Exporting file...</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                  <MDProgress variant="determinate" value={progress} style={{ width: '100%' }} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                  <Typography variant="body2" color="text.secondary">{`${Math.round(progress)}%`}</Typography>
                </Box>
              </Box>
            </Grid> :
            <MDTypography component='span' variant='body' fontSize='0.93rem' fontWeight='regular'>
              <p style={{ marginBottom: "0.2rem" }}> Click<Button variant="text" onClick={() => {
                setIsImportModalOpen(true);
              }} size="small" style={{ fontSize: "inherit", padding: "0.25rem", paddingBottom: "0.4rem", minWidth: "0", textTransform: "none" }}>here</Button>
                to Import people or salary data from a file</p>
              <p style={{ marginBottom: "0.2rem" }}> Click<Button variant="text" onClick={onExportData} size="small" style={{ fontSize: "inherit", padding: "0.25rem", paddingBottom: "0.4rem", minWidth: "0", textTransform: "none" }}>here</Button>
                to Export data to a file</p>
            </MDTypography>
          }
        </MDAlert>
      }
      <ConfirmationDialog
        showDialog={showConfirmationDialog}
        handleAccept={handleDelete}
        handleCancel={handleCloseConfirmation}
        heading={"Delete Person"}
        message={confirmDeleteMessage}
      />
      <WarningDialogWithTable
        showing={showing}
        showDialog={showWarningDialog}
        itemCount={itemCount}
        heading='Delete Person'
        message={warningMessage}
        tableData={tableData}
        handleAccept={handleCloseWarning}
        handleLinkClick={handleRouteToAttendeeClick}
      />
    </>
  )
}
